import React from 'react';
import { Button, styled, Typography } from '@mui/material';
import { Download } from '@mui/icons-material';
import ThaiFlagIcon from '@Components/Icons/ThaiFlagIcon';
import EngFlagIcon from '@Components/Icons/EngFlagIcon';
import Flex from '@Components/Bases/Flex';

const ButtonStyles = styled(Button)<{ isActive: boolean }>(() => ({
  fontWeight: 800,
  borderRadius: '32px',
  fontSize: '16px',
  cursor: 'pointer',
  '& .MuiButton-startIcon': {
    marginRight: '8px',
  },
}));

interface IPDFButtonProps {
  handleChipClick: (language: 'th' | 'en') => void;
  activeLanguage: 'th' | 'en';
  handleDownload: () => void;
}

const PDFButton: React.FC<IPDFButtonProps> = ({
  handleChipClick,
  activeLanguage,
  handleDownload,
}) => {
  return (
    <Flex justifyContent="space-between" alignItems="center">
      <Flex gap={2}>
        <Typography fontWeight={800} variant="h3">
          ภาษาที่ต้องการแสดงตัวอย่าง
        </Typography>
        <ButtonStyles
          isActive={activeLanguage === 'th'}
          startIcon={<ThaiFlagIcon />}
          onClick={() => handleChipClick('th')}
          color={activeLanguage === 'th' ? 'primary' : 'inherit'}
        >
          ภาษาไทย
        </ButtonStyles>
        <ButtonStyles
          isActive={activeLanguage === 'en'}
          startIcon={<EngFlagIcon />}
          onClick={() => handleChipClick('en')}
          color={activeLanguage === 'en' ? 'primary' : 'inherit'}
        >
          ภาษาอังกฤษ
        </ButtonStyles>
      </Flex>

      <Button color="inherit" startIcon={<Download />} onClick={handleDownload}>
        ดาวน์โหลดไฟล์
      </Button>
    </Flex>
  );
};

export default PDFButton;
